/* =========================================================
   EASTEAM — behaviour fixes, 2026-08-08
   1. Mobile menu: one tap to the collections, sub-groups collapsed
   2. Gift card PDP: a Checkout button beside Add to Cart
   ========================================================= */
(function () {
  'use strict';

  var MOBILE = '(max-width: 991px)';
  function isMobile() { return window.matchMedia(MOBILE).matches; }

  /* =======================================================
     1. MOBILE MENU

     Theme markup:
       .menu-wrapper > ul.navbar-sidebar
         > li.navbar__item.dropdown                  ← level 1 (DAYDREAM 2.0, SHOP)
             > div.navbar__link.menu-dropdwon
             > div.inner-navbar
                 > .inner-navbar__innerbox
                     > .inner-navbar__title          (back arrow)
                     > ul > li.dropdown              ← level 2 (This Season, By Occasion…)
                              > .grand-inner-navbar
                                  > ul > li > a       ← the actual collections

     DAYDREAM 2.0's level-2 groups ("This Season", "Archive") are just buckets,
     so they are dissolved and the four seasons list directly — one tap, done.
     SHOP's groups (By Occasion / By Category / By Collection) are real, separate
     axes, so they stay as collapsed rows you can open one at a time.
     ======================================================= */

  /* top-level items whose level-2 groups are only labels, not categories */
  var DISSOLVE = ['daydream 2.0'];

  function topPanel(li) { return li.querySelector(':scope > .inner-navbar'); }
  function subPanel(li) { return li.querySelector(':scope > .grand-inner-navbar'); }

  /* scrollHeight reads 0 while an ancestor is collapsed, so lift the cap for a
     frame, measure, and put it back. */
  function measure(panel) {
    var prev = panel.style.maxHeight;
    panel.style.transition = 'none';
    panel.style.maxHeight = 'none';
    var h = panel.scrollHeight;
    panel.style.maxHeight = prev;
    void panel.offsetHeight;
    panel.style.transition = '';
    return h;
  }

  /* after the animation, drop the cap so nothing can be clipped and the drawer
     scrolls the full list */
  function uncapWhenDone(li, panel) {
    var done = function (e) {
      if (e && e.propertyName && e.propertyName !== 'max-height') return;
      if (li.classList.contains('et-open')) panel.style.maxHeight = 'none';
      panel.removeEventListener('transitionend', done);
    };
    panel.addEventListener('transitionend', done);
    setTimeout(done, 480);
  }

  function closeItem(li) {
    li.classList.remove('et-open');
    var p = topPanel(li) || subPanel(li);
    if (p) p.style.maxHeight = '0px';
  }

  function openItem(li) {
    li.classList.add('et-open');
    var p = topPanel(li) || subPanel(li);
    if (!p) return;
    var h = measure(p);
    p.style.maxHeight = (h > 0 ? h + 40 : 1600) + 'px';
    uncapWhenDone(li, p);
  }

  /* lift a group's children into the list above it, then drop the empty group */
  function dissolveGroups(panel) {
    var ul = panel.querySelector('ul');
    if (!ul) return;
    Array.prototype.slice.call(ul.children).forEach(function (group) {
      if (group.tagName !== 'LI' || !group.classList.contains('dropdown')) return;
      var inner = subPanel(group);
      var innerUl = inner && inner.querySelector('ul');
      if (!innerUl) return;
      Array.prototype.slice.call(innerUl.children).forEach(function (child) {
        if (child.tagName === 'LI') ul.insertBefore(child, group);
      });
      ul.removeChild(group);
    });
  }

  function prepareMenu() {
    var wrap = document.querySelector('.menu-wrapper');
    if (!wrap || wrap.__etAccordion) return;
    var sidebar = wrap.querySelector('ul.navbar-sidebar');
    if (!sidebar) return;
    wrap.__etAccordion = true;
    wrap.classList.add('et-accordion');

    Array.prototype.slice.call(sidebar.children).forEach(function (li) {
      if (li.tagName !== 'LI' || !li.classList.contains('dropdown')) return;
      var panel = topPanel(li);
      if (!panel) return;

      li.classList.add('et-parent');
      panel.style.maxHeight = '0px';

      var label = (li.querySelector(':scope > .navbar__link') || {}).textContent || '';
      if (DISSOLVE.indexOf(label.trim().toLowerCase()) !== -1) {
        dissolveGroups(panel);
        return;
      }

      /* everything else keeps its groups, collapsed */
      Array.prototype.slice.call(panel.querySelectorAll('li.dropdown')).forEach(function (group) {
        var inner = subPanel(group);
        if (!inner) return;
        group.classList.add('et-sub');
        inner.style.maxHeight = '0px';
      });
    });
  }

  /* Capture phase, so the theme's own drill-down handler never runs. */
  document.addEventListener('click', function (e) {
    if (!isMobile()) return;
    var label = e.target.closest && e.target.closest('.menu-wrapper .navbar__link.menu-dropdwon');
    if (!label) return;
    var li = label.parentElement;
    if (!li) return;
    if (!li.classList.contains('et-parent') && !li.classList.contains('et-sub')) return;

    e.preventDefault();
    e.stopPropagation();

    if (li.classList.contains('et-open')) { closeItem(li); return; }
    /* one open branch per level keeps the drawer short */
    Array.prototype.slice.call(li.parentElement.children).forEach(function (sib) {
      if (sib !== li && sib.classList && sib.classList.contains('et-open')) closeItem(sib);
    });
    openItem(li);
  }, true);

  /* =======================================================
     2. GIFT CARD PDP — Checkout as well as Add to Cart

     Shopify's accelerated checkout buttons can't be used here because they skip
     the gift-card recipient fields. So post the form to /cart/add.js (which
     understands the properties[…] inputs, recipient email and message
     included) and then go straight to checkout.
     ======================================================= */
  function addGiftCardCheckout() {
    if (!document.body.classList.contains('template-suffix-gift-card')) return;
    var actions = document.querySelector('.product-actions');
    var form = document.querySelector('form[action*="/cart/add"], .main-product-form');
    if (!actions || !form || actions.querySelector('.et-gc-checkout')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'et-gc-checkout';
    btn.textContent = 'Checkout';
    actions.appendChild(btn);

    btn.addEventListener('click', function () {
      if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;

      var label = btn.textContent;
      btn.textContent = 'Taking you to checkout…';
      btn.disabled = true;

      var fd = new FormData(form);
      fd.append('__shopify_offset', String(new Date().getTimezoneOffset()));
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

      fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || 'Could not add the gift card.');
            window.location.href = root + 'checkout';
          });
        })
        .catch(function (err) {
          btn.textContent = label;
          btn.disabled = false;
          alert(err.message);
        });
    });
  }

  function boot() {
    if (isMobile()) prepareMenu();
    addGiftCardCheckout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* the drawer is built lazily on first open; the pre-order app also re-renders
     the buy block after load, which can drop the button */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.navbar-toggler, [data-mobile-hamburger]')) {
      setTimeout(boot, 60);
      setTimeout(boot, 400);
    }
  });
  setTimeout(addGiftCardCheckout, 900);
  setTimeout(addGiftCardCheckout, 2200);
  window.addEventListener('resize', function () { setTimeout(boot, 150); });
})();

/* =========================================================
   3. PDP "Previously on" — show every look for this product,
      not just the first 6; the row stays horizontally scrollable.
      Rebuilds the same shuffled list the PDP section builds, then
      appends the frames the section left out. Tapping any frame
      still opens the full-screen viewer (it always held all looks).
   ========================================================= */
(function () {
  'use strict';
  function expandPrevOn() {
    var root = document.querySelector('.ea-pdp');
    if (!root) return;
    var grid = root.querySelector('[data-ea-dmgrid]');
    if (!grid || grid.__etAllLooks) return;
    var have = grid.querySelectorAll('.dm-frame').length;
    if (!have) return;                       /* section hid or hasn't rendered yet */
    var dataEl = root.querySelector('[data-ea-data]');
    if (!dataEl) return;
    var D; try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var MY = root.dataset.handle;

    /* rebuild vids exactly as the PDP section does */
    var vids = [];
    (D.familyMedia || []).forEach(function (m) {
      if (m.handle !== MY || !m.url) return;
      var fn = String(m.url).split('?')[0].split('/').pop();
      if (vids.some(function (x) {
        return x.url === m.url || String(x.url).split('?')[0].split('/').pop() === fn;
      })) return;
      vids.push({ kind: (m.type === 'i' ? 'i' : 'v'), url: m.url, poster: m.poster });
    });
    (function seededShuffle(a, seedStr) {
      var s = 2166136261;
      for (var i = 0; i < seedStr.length; i++) { s ^= seedStr.charCodeAt(i); s = (s * 16777619) >>> 0; }
      function rnd() { s ^= s << 13; s ^= s >>> 17; s ^= s << 5; s >>>= 0; return s / 4294967296; }
      for (var j = a.length - 1; j > 0; j--) {
        var k = Math.floor(rnd() * (j + 1));
        var t = a[j]; a[j] = a[k]; a[k] = t;
      }
    })(vids, MY || 'ea');

    if (vids.length <= have) { grid.__etAllLooks = true; return; }
    function esc(s) {
      return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    }
    var html = '';
    for (var i = have; i < vids.length; i++) {
      var m = vids[i], inner;
      if (m.kind === 'i')      inner = '<img class="dm-img" alt="" loading="lazy" src="' + esc(m.url) + '">';
      else if (m.poster)       inner = '<img class="dm-img" alt="" loading="lazy" src="' + esc(m.poster) + '">';
      else                     inner = '<video class="dm-vid" muted playsinline preload="metadata" src="' + esc(m.url) + '#t=0.001"></video>';
      html += '<div class="dm-frame" data-ea-dmopen="' + i + '">' + inner + '<div class="dm-blur"></div></div>';
    }
    grid.insertAdjacentHTML('beforeend', html);
    grid.__etAllLooks = true;
  }
  function tryExpand() { setTimeout(expandPrevOn, 250); setTimeout(expandPrevOn, 1200); setTimeout(expandPrevOn, 3000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tryExpand);
  else tryExpand();
})();

/* ── PDP colour swatch paint ─────────────────────────────────────────────
   Merged products' Color option values have no linked swatch metaobject,
   so the section renders blank chips. Paint them from the colour name. */
(function () {
  var MAP = { brown:'#7A5A43', green:'#6B7050', pink:'#E8B4BC', white:'#F1ECE3',
    black:'#1B1614', grey:'#7E8085', gray:'#7E8085', red:'#9E3B34',
    blue:'#7791A3', yellow:'#C79A2E', cream:'#F1ECE3', ivory:'#F1ECE3',
    beige:'#D9C9B3', blush:'#E3B0AC', olive:'#6B7050', mocha:'#7A5A43' };
  function paint(root) {
    (root || document).querySelectorAll('.ea-pdp .swatch').forEach(function (b) {
      var chip = b.querySelector('.chip');
      if (!chip) return;
      var bg = (chip.getAttribute('style') || '');
      if (bg.indexOf('#') !== -1 && bg.indexOf('var(--stage)') === -1) return;
      var name = (b.getAttribute('title') || b.dataset.value || '').trim().toLowerCase();
      var hex = MAP[name];
      if (!hex) {
        for (var k in MAP) { if (name.indexOf(k) !== -1) { hex = MAP[k]; break; } }
      }
      if (hex) chip.style.background = hex;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { paint(); });
  } else { paint(); }
  document.addEventListener('shopify:section:load', function (e) { paint(e.target); });
})();
